import { render, staticRenderFns } from "./DrawingInspector.vue?vue&type=template&id=48a544e1&scoped=true"
import script from "./DrawingInspector.vue?vue&type=script&lang=js"
export * from "./DrawingInspector.vue?vue&type=script&lang=js"
import style0 from "./DrawingInspector.vue?vue&type=style&index=0&id=48a544e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a544e1",
  null
  
)

export default component.exports